import { render, staticRenderFns } from "./CouponDetails.vue?vue&type=template&id=158072f2"
import script from "./CouponDetails.vue?vue&type=script&lang=js"
export * from "./CouponDetails.vue?vue&type=script&lang=js"
import style0 from "./CouponDetails.vue?vue&type=style&index=0&id=158072f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports